<template>
  <button class="fast-bid-btn btn btn-blue" @click="selectBid">
    {{ btnLabel }}
  </button>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { trans } from "@/utils/trans";

  const emit = defineEmits(["selectBid"]);

  const props = defineProps<{
    userBidProp: number | null;
    placeBidProp: string | "default";
  }>();

  const btnLabel = computed(() => {
    let result = trans("lot.card_info_block.buttons.place_bid");
    if (props.userBidProp) {
      result =
        props.placeBidProp === "lot-page"
          ? trans("lot.card_info_block.buttons.rise_your_bid")
          : trans("lot.card_info_block.buttons.rise_bid");
    }

    return result;
  });

  const selectBid = () => {
    emit("selectBid");
  };
</script>
